import {
  SUREST_FILTER_DATA_SUCCESS,
  SUREST_FILTER_DATA_FAILURE,
  SUREST_FILTER_DATA_LOADING,
  SUREST_FILTER_DATA_REQUEST,
  SUREST_RELATIVE_COST_DRIVERS_SUCCESS,
  SUREST_RELATIVE_COST_DRIVERS_REQUEST,
  SUREST_RELATIVE_COST_DRIVERS_FAILURE,
  SUREST_RELATIVE_GRAPH_DATA_REQUEST,
  SUREST_RELATIVE_GRAPH_DATA_SUCCESS,
  SUREST_RELATIVE_GRAPH_DATA_FAILURE,
  SUREST_RELATIVE_GRAPH_DATA_LOADING,
  SUREST_RESET,
  SUREST_RELATIVE_DISTRIBUTION_REQUEST,
  SUREST_RELATIVE_DISTRIBUTION_SUCCESS,
  SUREST_RELATIVE_DISTRIBUTION_FAILURE,
  SUREST_RELATIVE_COMMON_SERVICES_REQUEST,
  SUREST_RELATIVE_COMMON_SERVICES_SUCCESS,
  SUREST_RELATIVE_COMMON_SERVICES_FAILURE,
} from '../../actions/actionTypes';

interface LocationData {
  DisplayName: string;
  PandoraProviderKey: string;
}

interface NpiDetail {
  NpiNumber: string;
  NpiName: string;
}

interface FilterItemData {
  Locations: LocationData[] | null;
  BenefitArcheType: string[] | null;
  NpiDetails: NpiDetail[] | null;
  PractitionerPrimarySpecialtyName: string[] | null;
}

interface SurestActionPayload {
  data?: unknown;
  error?: unknown;
  isLoading?: boolean;
}

interface SurestAction {
  type: string;
  payload?: SurestActionPayload | unknown;
}

interface SurestFilterState {
  filterData: FilterItemData[];
  loading: boolean;
  error: unknown;
  relativeCostDrivers: {
    data: unknown;
    error: unknown;
    loading: boolean;
  };
}

interface SurestRelativeCommonServicesState {
  data: unknown;
  error: unknown;
  loading: boolean;
}

interface SurestRelativeGraphState {
  graphData: unknown;
  graphLoading: boolean;
  graphError: unknown;
}

const initialState: SurestFilterState &
  SurestRelativeGraphState & {
    relativeDistribution: { data: unknown; error: unknown; loading: boolean };
    relativeCommonServices: SurestRelativeCommonServicesState;
  } = {
  filterData: [],
  loading: true,
  error: null,
  relativeCostDrivers: {
    data: {},
    error: {},
    loading: true,
  },
  graphData: null,
  graphLoading: true,
  graphError: null,
  relativeDistribution: {
    data: [],
    error: null,
    loading: true,
  },
  relativeCommonServices: {
    data: null,
    error: null,
    loading: true,
  },
};

const surestReducer = (state = initialState, action: SurestAction): typeof initialState => {
  switch (action.type) {
    case SUREST_RESET:
      return { ...initialState };

    case SUREST_FILTER_DATA_REQUEST:
      return {
        ...state,
        filterData: [],
        loading: true,
        error: null,
      };

    case SUREST_FILTER_DATA_SUCCESS:
      return {
        ...state,
        filterData: action.payload?.data || [],
        loading: false,
        error: null,
      };

    case SUREST_FILTER_DATA_FAILURE:
      return {
        ...state,
        error: action.payload?.error,
        loading: false,
        filterData: [],
      };

    case SUREST_FILTER_DATA_LOADING:
      return {
        ...state,
        loading: action.payload?.isLoading,
      };
    case SUREST_RELATIVE_COST_DRIVERS_SUCCESS:
      return {
        ...state,
        relativeCostDrivers: {
          ...state.relativeCostDrivers,
          data: action.payload || {},
          error: null,
          loading: false,
        },
      };
    case SUREST_RELATIVE_COST_DRIVERS_FAILURE:
      return {
        ...state,
        relativeCostDrivers: {
          ...state.relativeCostDrivers,
          error: action.payload || {},
          loading: false,
          data: {},
        },
      };
    case SUREST_RELATIVE_COST_DRIVERS_REQUEST:
      return {
        ...state,
        relativeCostDrivers: {
          ...state.relativeCostDrivers,
          data: {},
          loading: true,
          error: {},
        },
      };

    case SUREST_RELATIVE_DISTRIBUTION_REQUEST:
      return {
        ...state,
        relativeDistribution: {
          ...state.relativeDistribution,
          data: [],
          loading: true,
          error: {},
        },
      };
    case SUREST_RELATIVE_DISTRIBUTION_SUCCESS:
      return {
        ...state,
        relativeDistribution: {
          ...state.relativeDistribution,
          data: action.payload || {},
          loading: false,
          error: null,
        },
      };
    case SUREST_RELATIVE_DISTRIBUTION_FAILURE:
      return {
        ...state,
        relativeDistribution: {
          ...state.relativeDistribution,
          error: action.payload || {},
          loading: false,
          data: {},
        },
      };

    case SUREST_RELATIVE_GRAPH_DATA_REQUEST:
      return {
        ...state,
        graphData: null,
        graphLoading: true,
        graphError: null,
      };

    case SUREST_RELATIVE_COMMON_SERVICES_REQUEST:
      return {
        ...state,
        relativeCommonServices: { data: null, error: null, loading: true },
      };
    case SUREST_RELATIVE_COMMON_SERVICES_SUCCESS:
      return {
        ...state,
        relativeCommonServices: { data: action.payload || null, error: null, loading: false },
      };
    case SUREST_RELATIVE_COMMON_SERVICES_FAILURE:
      return {
        ...state,
        relativeCommonServices: { data: null, error: action.payload, loading: false },
      };

    case SUREST_RELATIVE_GRAPH_DATA_SUCCESS:
      return {
        ...state,
        graphData: action.payload,
        graphLoading: false,
        graphError: null,
      };

    case SUREST_RELATIVE_GRAPH_DATA_FAILURE:
      return {
        ...state,
        graphError: action.payload?.error,
        graphLoading: false,
        graphData: null,
      };

    case SUREST_RELATIVE_GRAPH_DATA_LOADING:
      return {
        ...state,
        graphLoading: action.payload?.isLoading,
      };

    default:
      return state;
  }
};

export default surestReducer;
